module.exports = __webpack_public_path__ + "static/img/14000472.764336dc.png";